export const messages = {
  en: {
    printAllocationStorehouse:{
    title: 'Allocation Storehouse Print',
    applyId: 'Apply ID',
    startUserName: 'Applicant',
    createTime: 'Apply Time',
    number: 'No.',
    resName: 'Allocation Item',
    resType: 'Item Type',
    specName: 'Item Specification',
    resCode: 'Item Code',
    isFixedName: 'Fixed Item',
    source: 'Source',
    targetStorehouse: 'Target Storehouse',
    originalStock: 'Original Stock',
    allocationQuantity: 'Allocation Quantity',
    remark: 'Remark',
    storeManagerSign: 'Store Manager Sign',
    allocationStaffSign: 'Allocation Staff Sign',
    time: 'Time',
    fetchError: 'Failed to get allocation information',
  }
  },
  zh: {
    printAllocationStorehouse:{
    title: '调拨仓库打印',
    applyId: '申请单号',
    startUserName: '申请人',
    createTime: '申请时间',
    number: '编号',
    resName: '调拨物品',
    resType: '物品类型',
    specName: '物品规格',
    resCode: '物品编码',
    isFixedName: '固定物品',
    source: '来源',
    targetStorehouse: '目标仓库',
    originalStock: '原库存',
    allocationQuantity: '调拨数量',
    remark: '备注',
    storeManagerSign: '仓库管理员签字',
    allocationStaffSign: '调拨人员签字',
    time: '时间',
    fetchError: '获取调拨信息失败'
    }
  },
  'zh-TW': {
    printAllocationStorehouse:{
    title: '調撥倉庫列印',
    applyId: '申請單號',
    startUserName: '申請人',
    createTime: '申請時間',
    number: '編號',
    resName: '調撥物品',
    resType: '物品類型',
    specName: '物品規格',
    resCode: '物品編碼',
    isFixedName: '固定物品',
    source: '來源',
    targetStorehouse: '目標倉庫',
    originalStock: '原庫存',
    allocationQuantity: '調撥數量',
    remark: '備註',
    storeManagerSign: '倉庫管理員簽字',
    allocationStaffSign: '調撥人員簽字',
    time: '時間',
    fetchError: '獲取調撥信息失敗'
    }
  }
}
